module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section is-dark"
  }, [_c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "col lg-4 md-12 flexh-align-top no-margin-bottom-lg"
  }, [_c('div', {
    staticClass: "fa is-24px is-brand-color margin-right"
  }, [_vm._v("")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "size-h4 margin-bottom-small on-dark"
  }, [_vm._v("Flexible Return")]), _vm._v(" "), _c('div', {
    staticClass: "low-text-contrast text-small"
  }, [_vm._v("30 day return window without any question asked, and  also get a full refund, simply a peace of mind.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-4 md-12 flexh-align-top no-margin-bottom-lg"
  }, [_c('div', {
    staticClass: "fa is-24px is-brand-color margin-right"
  }, [_vm._v("")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "size-h4 margin-bottom-small on-dark"
  }, [_vm._v("Nationwide shipping")]), _vm._v(" "), _c('div', {
    staticClass: "low-text-contrast text-small"
  }, [_vm._v("We accept order around the country and deliver your orders within 72 hours.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-4 md-12 flexh-align-top no-margin-bottom"
  }, [_c('div', {
    staticClass: "fa is-24px is-brand-color margin-right"
  }, [_vm._v("")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "size-h4 margin-bottom-small on-dark"
  }, [_vm._v("Secure payment")]), _vm._v(" "), _c('div', {
    staticClass: "low-text-contrast text-small"
  }, [_vm._v("All transactions are encrypted with the encryption of standard SSL with 128-bit symmetric key")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "section padding-bottom-16 is-dark no-padding-top"
  }, [_c('div', {
    staticClass: "container margin-bottom-double is-wide"
  }, [_c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('div', {
    staticClass: "hr on-dark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container margin-bottom is-wide"
  }, [_c('div', {
    staticClass: "col lg-4 md-12 no-margin-bottom-lg"
  }, [_c('img', {
    staticClass: "margin-bottom",
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "low-text-contrast margin-bottom"
  }, [_vm._v("Stanel World  "), _c('br'), _vm._v("Nigeria"), _c('br'), _vm._v("Tel: +234000000000"), _c('br'), _vm._v("info@stanel.com")]), _vm._v(" "), _c('div', {
    staticClass: "flex-horizontal low-text-contrast"
  }, [_c('div', {
    staticClass: "fa-brand margin-right-small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "fa-brand margin-right-small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "fa-brand margin-right-small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "fa-brand margin-right-small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-6 md-12"
  }, [_c('div', {
    staticClass: "container container-nested"
  }, [_c('div', {
    staticClass: "col lg-4 md-12 no-margin-bottom-lg"
  }, [_c('h4', {
    staticClass: "on-dark"
  }, [_vm._v("Tour")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "farmmarket"
    }
  }, [_vm._v("Farmer's Market")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "pjsupermerket"
    }
  }, [_vm._v("P & J Supermaket")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "essencespa"
    }
  }, [_vm._v("Essence Spa")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "chickenrepublic"
    }
  }, [_vm._v("Chicken republic")])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-4 md-12 no-margin-bottom-lg"
  }, [_c('h4', {
    staticClass: "on-dark"
  }, [_vm._v("Read")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shipping & return")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Affiliate")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Privacy & Policy")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Handling")])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-4 md-12 no-margin-bottom"
  }, [_c('h4', {
    staticClass: "on-dark"
  }, [_vm._v("About Us")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Locations")]), _vm._v(" "), _c('a', {
    staticClass: "footer-nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Carreer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-2 md-12 flex-vertical no-margin-bottom"
  }, [_c('h4', {
    staticClass: "margin-bottom on-dark"
  }, [_vm._v("Get Our Store App ")]), _c('img', {
    staticClass: "max-width-200px",
    attrs: {
      "src": "https://via.placeholder.com/1000x600.png?text=IMAGE",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "col lg-12 margin-bottom"
  }, [_c('div', {
    staticClass: "hr on-dark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "col lg-6 no-margin-bottom md-12 md-order-last"
  }, [_c('div', {
    staticClass: "low-text-contrast text-small flexh-space-between md-flex-vertical"
  }, [_c('div', {
    staticClass: "md-order-last"
  }, [_vm._v("©2019 Stanel World. All rights reserved. ")]), _c('a', {
    staticClass: "footer-bottom-link",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Privacy Policy")]), _c('a', {
    staticClass: "footer-bottom-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Term Of Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-6 no-margin-bottom md-12"
  }, [_c('div', {
    staticClass: "w100 text-align-right footer-bottom md-text-align-left margin-bottom"
  }, [_vm._v("Radar Secured")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0c39ee"}!./src/pages/MainFooter/template.html
// module id = 237
// module chunks = 0